import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

import { representativesApi } from './representativesApi';
import { Representative } from './types';

interface RepresentativeState {
  representative?: Representative;
}

const initialState: RepresentativeState = {
  representative: undefined,
};

const representativeSlice = createSlice({
  name: 'representativeInfo',
  initialState,
  reducers: {
    _: () => {},
  },
  extraReducers: builder =>
    builder.addMatcher(
      representativesApi.endpoints?.getRepresentativeByIdentityId
        .matchFulfilled,
      (state, action: PayloadAction<Representative>) => {
        state.representative = action.payload;
      },
    ),
  selectors: {
    selectCurrentRepresentative: state => state.representative,
  },
});

export default representativeSlice;

export const useRepresentativeByIdentityId = () =>
  useSelector(representativeSlice.selectors.selectCurrentRepresentative);
